import "@/styles/headerStyle.less";
import React from "react";
import Header from "./header";
import Nav from "./navigation";

const Index = () => {
  return (
    <div>
      <div className="Component-container">
        <div className="Component-item-header">
          <Header></Header>
        </div>
        <Nav></Nav>
      </div>

    </div>
  );
};

export default Index;
